// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3_1rr","requiredAsterisk":"Info_requiredAsterisk__1aBPk"};